import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { formatMoney } from "../../i18n/formatNumber";
import { buildStudentSettlementSummary } from "./studentSettlementTotals";

export default function StudentSettlementSummary({ settlement }) {
  const { t, i18n } = useTranslation("billing");
  const summary = buildStudentSettlementSummary(settlement);
  const money = value => formatMoney(value / 100, i18n.language);
  const unknown = t("studentCosts.unknown", { defaultValue: "Brak danych historycznych" });
  const rows = [...summary.students];
  if (summary.otherCharges.finalAmountCents || summary.otherCharges.unknownHistoryCount) rows.push(summary.otherCharges);
  return (
    <div className="table-responsive mb-3">
      <table className="table table-sm">
        <caption className="sr-only">{t("studentCosts.title", { defaultValue: "Koszty uczniów" })}</caption>
        <thead>
          <tr>
            <th scope="col">{t("studentCosts.student", { defaultValue: "Uczeń" })}</th>
            <th scope="col">{t("studentCosts.base", { defaultValue: "Przed zniżką" })}</th>
            <th scope="col">{t("studentCosts.discount", { defaultValue: "Zniżka" })}</th>
            <th scope="col">{t("studentCosts.final", { defaultValue: "Po zniżce" })}</th>
          </tr>
        </thead>
        <tbody>{rows.map(row => (
          <tr key={row.studentId || "other"}>
            <th scope="row">{row.studentId ? row.studentName : t("studentCosts.other", { defaultValue: "Pozostałe opłaty" })}</th>
            <td>{row.unknownHistoryCount ? unknown : money(row.baseAmountCents)}</td>
            <td>{row.unknownHistoryCount ? unknown : money(row.discountAmountCents)}</td>
            <td>{money(row.finalAmountCents)}</td>
          </tr>
        ))}
        </tbody>
        <tfoot>
          <tr>
            <th scope="row">{t('studentCosts.total')}</th>
            <td>{summary.unknownHistoryCount ? unknown : money(summary.finalAmountCents + summary.knownDiscountCents)}</td>
            <td>{summary.unknownHistoryCount ? unknown : money(summary.knownDiscountCents)}</td>
            <td>{money(summary.finalAmountCents)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

StudentSettlementSummary.propTypes = { settlement: PropTypes.object.isRequired };
